import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

interface CountBubbleProps {
    count: number;
    color?: string;
    backgroundColor?: string;
}

export function CountBubble({ count, color = Colors.white, backgroundColor = Colors.turquoise }: CountBubbleProps) {
    return (
        <Bubble color={color} backgroundColor={backgroundColor}>
            {count}
        </Bubble>
    );
}

const Bubble = styled('span')<{
    color: string;
    backgroundColor: string;
}>(({ color, backgroundColor }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 22,
    height: 22,
    padding: '0 6px',
    borderRadius: 11,
    fontSize: 12,
    fontWeight: 600,
    backgroundColor: backgroundColor,
    color: color,
}));
